import React from 'react';
import { Size } from '../../../styles/theme.mjs';
import InputWithButton from '../../Basic/InputWithButton/InputWithButton.mjs';
import DesktopOnly from '../../Containers/DesktopOnly/DesktopOnly.mjs';
import MobileOnly from '../../Containers/MobileOnly/MobileOnly.mjs';
import Heading from '../../Typography/Heading/Heading.mjs';
import TextComponent from '../../Typography/Text/Text.mjs';
import { StyledNewsLetterWrapper, StyledNewsletterBackgroundBig, StyledNewsletterBackgroundSmall } from './Newsletter.styles.mjs';

const Newsletter = ({ heading, description, errorMessage, className, onChange, onSubmit, padding }) => {
    return (React.createElement(StyledNewsLetterWrapper, { padding: padding },
        React.createElement(Heading, { tag: "h2" }, heading),
        React.createElement(TextComponent, { tag: "p", size: Size.Small }, description),
        React.createElement(InputWithButton, { buttonAriaLabel: "Subscribe to newsletter", buttonText: "Subscribe", errorMessage: errorMessage, placeholder: "Your email address", className: className, onChange: onChange, onSubmit: onSubmit }),
        React.createElement(DesktopOnly, null,
            React.createElement(StyledNewsletterBackgroundBig, null)),
        React.createElement(MobileOnly, null,
            React.createElement(StyledNewsletterBackgroundSmall, null))));
};

export { Newsletter as default };
//# sourceMappingURL=Newsletter.mjs.map
